// Reducer is exposed so that we can hook it up to the store creation
export { default as serverMenuReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'



// WEBPACK FOOTER //
// ./src/features/ServerMenu/exports.js